// Wraps case-insensitive occurrences of the query in <mark>, for search results.
import type { ComponentChildren } from 'preact';

export function splitMatches(text: string, q: string): { t: string; hit: boolean }[] {
  const query = q.trim();
  if (!query || !text) return [{ t: text, hit: false }];
  const low = text.toLowerCase(), lq = query.toLowerCase();
  const out: { t: string; hit: boolean }[] = [];
  let i = 0;
  for (;;) {
    const j = low.indexOf(lq, i);
    if (j < 0) break;
    if (j > i) out.push({ t: text.slice(i, j), hit: false });
    out.push({ t: text.slice(j, j + query.length), hit: true });
    i = j + query.length;
  }
  if (i < text.length) out.push({ t: text.slice(i), hit: false });
  return out.length ? out : [{ t: text, hit: false }];
}

export function Highlight({ text, q }: { text: string; q: string }): ComponentChildren {
  return splitMatches(text, q).map((p, k) => (p.hit ? <mark key={k}>{p.t}</mark> : p.t));
}
